import moment from "jalali-moment";
import { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import endpoints from "../../../config/endpoints";
import orderEnum from "../../../enums/orderEnum";
import useTicker from "../../../hooks/useTicker";
import { popupSlice } from "../../../services/reducers";
import { setLoading } from "../../../services/reducers/homeSlice";
import restApi from "../../../services/restApi";
import { Sidebar } from "../../../layouts/Sidebar";
import alertHandler from "../../../utils/alertHandler";
import tools from "../../../utils/tools";
import BillDetail from "./‌BillDetail";
import Status = orderEnum.Status;

const Pricing = () => {
  const [data, setData] = useState<any>();
  const [statuses, setStatuses] = useState([]);
  const [query, setQuery] = useState("");
  const [tab, setTab] = useState("all");
  const [stores, setStores] = useState([]);
  const [providers, setProviders] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const deleteOrder = async (id: number) => {
    if (confirm("آیا مطمئن هستید؟")) {
      dispatch(setLoading(true));

      const res = await restApi(
        process.env.REACT_APP_BASE_URL + "/admin/order/" + id,
        true,
      ).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: "موفق",
          text: "سفارش با موفقیت حذف شد",
          icon: "success",
          confirmButtonText: "متوجه شدم",
        });
      } else {
        Swal.fire({
          title: "ناموفق",
          text: res?.data,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
      }

      dispatch(setLoading(false));
    }
  };

  const handleSelect = async (id: number, buyer: string) => {
    if (confirm("آیا مطمئن هستید؟")) {
      const res = await restApi(endpoints.orderProduct.buyer + id, true).put({
        buyerId: buyer,
      });

      alertHandler(res, "خریدار با موفقیت تغییر کرد");

      dispatch(setLoading(false));
    }
  };

  const list = () => {
    const rows: ReactElement[] = [];

    data
      ?.filter(
        (e) =>
          e.order?.code?.includes(query) &&
          tools.orderStatusIs(e.order?.orderStatusSlug, [
            Status.SetPrice,
            Status.PickBuyer,
          ]),
      )
      .sort((a, b) => b.id - a.id)
      .map((orderProduct: any, index) => {
        rows.push(
          <tr className="dashTr2" key={"order" + index}>
            <td className="svgContainer">
              <i
                className="trash clickable"
                onClick={() => deleteOrder(orderProduct.id)}
              ></i>
              <i
                className="edit clickable"
                onClick={() =>
                  navigate("/order/pricing/edit/" + orderProduct.id)
                }
              ></i>
              <i
                className="factorSvg clickable"
                onClick={() =>
                  dispatch(
                    popupSlice.middle(
                      <BillDetail
                        stores={stores}
                        orderProduct={orderProduct}
                        fetchData={fetchData}
                      />,
                    ),
                  )
                }
              ></i>
              <i></i>
            </td>
            {orderProduct?.order?.orderStatusSlug == Status.PickBuyer && (
              <td>
                <select
                  className="billInput width63"
                  onChange={(input) =>
                    handleSelect(orderProduct.id, input.target.value)
                  }
                  value={orderProduct?.buy?.buyerId}
                >
                  <option value={0}>انتخاب کنید</option>
                  {providers?.map((e) => (
                    <option value={e.id}>{e.name}</option>
                  ))}
                </select>
              </td>
            )}
            <td className="">
              {moment(orderProduct?.createdAt).format("jYYYY/jMM/jDD HH:MM")}
            </td>
            <td className="">{orderProduct?.count}</td>
            <td className="">{`${orderProduct?.attribute?.attributeSpecific?.specific?.title || ""} : ${orderProduct?.attribute?.attributeSpecific?.specificValue?.title || ""}`}</td>
            <td className="">{orderProduct?.product?.car?.slug}</td>
            <td className="">{orderProduct?.product?.part?.title}</td>
            <td className="">{orderProduct?.product?.title}</td>
            <td className="">{orderProduct?.order?.code}</td>
          </tr>,
        );
      });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    await Promise.all([
      await restApi(endpoints.orderProduct.index).get(),
      await restApi(
        process.env.REACT_APP_BASE_URL + "/order/status",
        true,
      ).get(),
      await restApi(endpoints.store.index).get(),
      await restApi(endpoints.user.index).get({ role: "provide" }),
    ]).then((res) => {
      setData(res[0].data);
      setStatuses(res[1].data);
      setStores(res[2].data);
      setProviders(res[3].data);
    });

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar />
        <div className="dashBoardMain">
          <h1 className="dashBoardTitle">سفارش ها</h1>
          <div className="searchContainer">
            <span className="backSpan keepRight">
              {/*  <span className="dashboardHeader clickable" onClick={() => dispatch(popupSlice.middle(<Excel />))}> */}
              {/*   <p>بارگزاری فایل اکسل</p> */}
              {/*   <i className="exelSvg"></i> */}
              {/* </span> */}
              {/* <span className="dashboardHeader clickable" onClick={() => dispatch(popupSlice.middle(<Derham />))}> */}
              {/*   <p>قیمت روز درهم</p> */}
              {/*   <i className="derhamSvg"></i> */}
              {/* </span> */}
            </span>
            <div className="dashboardseaechBox">
              <i className="dashMagnifierIcon"></i>
              <input
                className="dashSearchInput"
                placeholder="جستجو"
                onChange={(input: any) => setQuery(input.target.value)}
              ></input>
            </div>
          </div>
          <table>
            <thead>
              <tr className="dashTr1 blueText">
                <th>عملیات</th>
                <th>تاریخ</th>
                <th>تعداد</th>
                <th>جزئیات</th>
                <th>نام ماشین</th>
                <th>نوع کالا</th>
                <th>نام کالا</th>
                <th>شماره سفارش</th>
              </tr>
            </thead>
            <tbody>{list()}</tbody>
          </table>
        </div>
      </main>
    </>
  );
};
export default Pricing;
